import { render, staticRenderFns } from "./DraggableUploadedBackendFiles.vue?vue&type=template&id=462caf08&scoped=true"
import script from "./DraggableUploadedBackendFiles.vue?vue&type=script&lang=js"
export * from "./DraggableUploadedBackendFiles.vue?vue&type=script&lang=js"
import style0 from "./DraggableUploadedBackendFiles.vue?vue&type=style&index=0&id=462caf08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462caf08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow})
